module.exports = __webpack_public_path__ + "img/default-avatar.253a7f1c.svg";